/* eslint-disable max-len */
import React from 'react'

const SubscribeSuccess = ({subscriptionDetails, subscriptionSuccessModal}) => {
    return (
        <div className={`modal fade fixed top-0 left-0 w-full h-full ${subscriptionSuccessModal ? 'show' : 'hidden'}  outline-none overflow-x-hidden overflow-y-auto`} id="successBulkOffer" tabIndex="-1" aria-labelledby="successBulkOffer" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:min-w-[443px] min-w-full px-3 mx-auto" style={{margin: 'auto'}}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current sm:px-5 px-4">
                    <div className="modal-body relative sm:pt-[38px] pt-5 sm:pb-8 pb-5 text-center">
                        <img src="/images/success-filled.svg" alt="icon" className="mx-auto"/>
                        <p className="text-sm56 font-semibold text-[#090406] pt-3.5 text-center">Subscribed to Bulk Offer!</p>
                        <p className="text-sm44 font-semibold text-[#555259] text-center pt-1.5">Subscription ID:{subscriptionDetails.subscription_id}</p>
                        <p className="sm:text-base text-sm font-normal text-[#555259] text-center">
                            To avail the fulfilment discount you have to achieve the necessary criteria within the specified time period. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubscribeSuccess